'use client'

import { useEffect } from 'react'
import { MModal, CLocaleSwitcherBody } from 'ui'
import { LocaleSwitcherEntry } from 'tsconfig/craft-types'

type Props = {
  open: boolean
  onClose: Function
  domain: string
  entry?: LocaleSwitcherEntry
}

export const CLocaleSwitcher = ({ open, onClose, domain, entry }: Props) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeModal()
    }
  }

  const closeModal = () => {
    if (onClose instanceof Function) {
      onClose()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <div className="c-locale-switcher">
      <MModal open={open} onClose={closeModal}>
        <CLocaleSwitcherBody domain={domain} entry={entry} />
      </MModal>
    </div>
  )
}
